<template lang="pug">
.sendmail-confirm-modal
  b-modal(v-model="_modalShow" size="lg" no-close-on-backdrop no-close-on-esc @ok="send")
    div(slot="modal-title")
      span 以下の内容でメッセージを送信します。よろしいですか？

    .sendmail-confirm-modal-body
      .register-body
        FormLabel(key-name="宛先メールアドレス" :value="_mailAddress")
        FormLabel(key-name="タイトル" :value="_subject")
        FormLabel(key-name="本文" :value="_text")

    .sendmail-confirm-modal-footer(slot="modal-footer" slot-scope="{ ok, cancel }")
      .buttons.d-flex.justify-content-end
        button.btn.modal-ok-btn.mr-2(type="button" @click="ok()") OK
        button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import FormLabel from "@/pc/components/forms/FormLabel.vue";

/**
 * メール送信確認モーダル
 */
@Component({
  components: {
    FormLabel
  }
})
export default class SendMailConfirmModal extends Vue {
  @Prop({
    default: () => {
      return false;
    }
  })
  value!: boolean;

  @Prop({
    default: () => {
      return "";
    }
  })
  mailAddress!: string;

  @Prop({
    default: () => {
      return "";
    }
  })
  subject!: string;

  @Prop({
    default: () => {
      return "";
    }
  })
  text!: string;

  get _modalShow(): boolean {
    return this.value;
  }

  set _modalShow(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _mailAddress(): string {
    return this.mailAddress;
  }

  get _subject(): string {
    return this.subject;
  }

  get _text(): string {
    return this.text;
  }

  /**
   * ### OKボタン押下処理
   */
  public send(modalEvent: any): void {
    modalEvent.preventDefault();
    this.$emit("sendMail");
    return;
  }
}
</script>
